export default __webpack_public_path__ + "static/media/thumbnail-01.91019d93.png";